/* eslint-disable camelcase */
/* eslint-disable no-useless-escape */
import * as Yup from 'yup';

export const getValidationSchema = () =>
  Yup.object({
    old_password: Yup.string().required('Please fill out the rest fields. This is mandatory.'),
    password: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .max(64, 'Password must not exceed 64 characters')
      .matches(/(?=.*\d)/, 'Include at least one number')
      .matches(/(?=.*[!@#$%^&*])/, 'Include at least 1 special character (!@#$%^&*)')
      .matches(/(?=.*[a-z])/, 'Include at least 1 lowercase letter')
      .matches(/(?=.*[A-Z])/, 'Include at least 1 uppercase letter')
      .required('Please fill out the rest fields. This is mandatory.'),
    password_confirmation: Yup.string()
      .oneOf([Yup.ref('password'), null], 'Confirmation doesn`t match your password')
      .required('Please fill out the rest fields. This is mandatory.'),
  });
